import { createContext, useContext, useState } from 'react'

// Preview role context — super_admins can "view as" another role without
// signing out. Client-side only; RLS policies still honor the real role
// for database queries. Does NOT persist across page refreshes.

const PreviewRoleContext = createContext({
  previewRole: null,
  setPreviewRole: () => {},
})

export function PreviewRoleProvider({ children }) {
  const [previewRole, setPreviewRole] = useState(null)
  return (
    <PreviewRoleContext.Provider value={{ previewRole, setPreviewRole }}>
      {children}
    </PreviewRoleContext.Provider>
  )
}

export function usePreviewRole() {
  return useContext(PreviewRoleContext)
}
